import {Action} from '@ngrx/store';

export const CREATE_TREATY = '[Treaty] CREATE_TREATY';
export const CREATE_TREATY_SUCCESS = '[Treaty] CREATE_TREATY_SUCCESS';
export const CREATE_TREATY_FAIL = '[Treaty] CREATE_TREATY_FAIL';

export const GET_OTHER_DOCUMENT_INFO = '[Treaty] GET_OTHER_DOCUMENT_INFO';
export const GET_OTHER_DOCUMENT_INFO_SUCCESS = '[Treaty] GET_OTHER_DOCUMENT_INFO_SUCCESS';
export const GET_OTHER_DOCUMENT_INFO_FAIL = '[Treaty] GET_OTHER_DOCUMENT_INFO_FAIL';


export class GetOtherDocumentInfoAction implements Action {
  readonly type = GET_OTHER_DOCUMENT_INFO;
  constructor() {
  }
}
export class GetOtherDocumentInfoSuccessAction implements Action {
  readonly type = GET_OTHER_DOCUMENT_INFO_SUCCESS;
  constructor(public payload: any) {
  }
}
export class GetOtherDocumentInfoFailAction implements Action {
  readonly type = GET_OTHER_DOCUMENT_INFO_FAIL;
  constructor(public erro: any) {
  }
}

export class CreateTreatyAction implements Action {
  readonly type = CREATE_TREATY;
  constructor(public command: any) {
  }
}
export class CreateTreatySuccessAction implements Action {
  readonly type = CREATE_TREATY_SUCCESS;

  constructor(public payload: any) {
  }
}
export class CreateTreatyFailedAction implements Action {
  readonly type = CREATE_TREATY_FAIL;

  constructor(public error: any) {
  }
}

export type TreatyActions =
  CreateTreatyAction
| CreateTreatySuccessAction
  | CreateTreatyFailedAction
| GetOtherDocumentInfoAction
| GetOtherDocumentInfoSuccessAction
| GetOtherDocumentInfoFailAction;



